import { render, staticRenderFns } from "./affirmMileage.vue?vue&type=template&id=768a2c9c&scoped=true&"
import script from "./affirmMileage.vue?vue&type=script&lang=js&"
export * from "./affirmMileage.vue?vue&type=script&lang=js&"
import style0 from "./affirmMileage.vue?vue&type=style&index=0&id=768a2c9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768a2c9c",
  null
  
)

export default component.exports